export default __webpack_public_path__ + "static/media/information--equestrians-permitted--g1.a22f8bf3.png";